export default __webpack_public_path__ + "static/media/bandcamp.cc8faccf.svg";